var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.337h512v341.326H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0110.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 01-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95l-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.338 146.448l-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189l-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013l-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M83.478 85.337h89.043v341.326H83.478z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M117.458 175.191l-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
  fill: "#ff9811"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M117.458 374.725l-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
  fill: "#ff9811"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M117.458 274.957l-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
  fill: "#496e2d"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.576 248.576h14.84v14.84h-14.84z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 206.113,
  r: 7.421
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 305.887,
  r: 7.421
}))));

export default SvgTm;